import { ReactNode } from 'react';
import classnames from 'classnames';

interface Props {
  icon: ReactNode;
  label: string;
  /** A link-style action next to the label, e.g. "Pickup or delivery". */
  action?: { label: string; onClick: () => void };
  className?: string;
}

/** The one order type a guest is in, shown in place of the Pickup / Delivery toggle. */
export default function OrderTypeLabel(props: Props) {
  const { icon, label, action, className } = props;

  return (
    <div className={classnames(container, className)} data-test="order-type-label">
      <p className={labelStyle}>
        {icon}
        {label}
      </p>
      {action && (
        <button type="button" onClick={action.onClick} className={actionStyle} data-test="order-type-label-action">
          {action.label}
        </button>
      )}
    </div>
  );
}

// Values from the design (Browse first's order type label, the design system's link button, sm).
const container = 'flex flex-wrap items-center justify-between gap-[12px]';
const labelStyle =
  'flex items-center gap-[8px] min-h-[40px] pl-[13px] m-0 text-[14px] font-semibold text-brand-text-primary';
const actionStyle =
  'h-[32px] px-[12px] rounded-sm text-[13px] font-semibold text-brand-text-primary underline underline-offset-2 hover:decoration-2';
